/**
 * @generated SignedSource<<abe09cd4365b0d121e2e4d7a9561be88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventSlot_eventSession$data = {
  readonly id: string;
  readonly " $fragmentType": "EventSlot_eventSession";
};
export type EventSlot_eventSession$key = {
  readonly " $data"?: EventSlot_eventSession$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSlot_eventSession">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSlot_eventSession",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "EventSession",
  "abstractKey": null
};

(node as any).hash = "7b82448aea53414d6c80e42e7a2b568d";

export default node;
